import { render, staticRenderFns } from "./view_service_report_file.vue?vue&type=template&id=4b126a58&scoped=true"
import script from "./view_service_report_file.vue?vue&type=script&lang=js"
export * from "./view_service_report_file.vue?vue&type=script&lang=js"
import style0 from "./view_service_report_file.vue?vue&type=style&index=0&id=4b126a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b126a58",
  null
  
)

export default component.exports